module.exports = __webpack_public_path__ + "static/img/task.f778ca10.svg";